import React, { useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useQuery } from "@tanstack/react-query";

import { useSelector } from "react-redux";

import { Skeleton } from "@mui/material";

// import { Table } from "antd";
import { getAdminUserDetail } from "../../connections/getAdminUserDetail";
import { deleteAdminUser } from "../../connections/deleteUserAdmin";
import { toast } from "react-toastify";
import { imagesend } from "../imagepath";
import { formatDateTime } from "../../utils/constant/constant";

const AdminUserDetails = () => {
  const {
    user: { user },
  } = useSelector((store) => store);
  const { id } = useParams();
  const [deleteId, setDeleteId] = useState(null);
  const navigate = useNavigate();
  const { data: getAdminUserData, isLoading } = useQuery({
    queryKey: ["getAdminUserDetail", id],
    queryFn: () => getAdminUserDetail(user?.token, id),
    enabled: !!id,
    // staleTime: Infinity, // Keep the data fresh indefinitely

    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });
  const formatDate = (date) => formatDateTime(date);
  const handleDeleteUserAdmin = async (e) => {
    e.preventDefault();

    try {
      const data = await deleteAdminUser(user?.token, deleteId);
      if (data.status.status === "SUCCESS") {
        toast.success("Admin User Deleted Successfully");
        navigate(-1);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <>
      <Header />
      <Sidebar activeClassName="admin-user-list" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item active">
                      <Link to={-1}>Admin User Details</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">{id}</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    {/* content Header */}
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="doctor-table-blk"
                          >
                            <h3>Admin User Details</h3>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                              className="doctor-search-blk"
                            >
                              <button
                                className="btn btn-sm btn-primary d-flex align-items-center justify-content-center"
                                style={{
                                  minWidth: "100px",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                }}
                                onClick={() => {
                                  navigate("/admin/update_admin_user", {
                                    state: getAdminUserData,
                                  });
                                }}
                              >
                                <i className="far fa-edit me-2" />
                                Edit
                              </button>
                              <button
                                className="btn btn-sm btn-danger d-flex align-items-center justify-content-center"
                                style={{
                                  minWidth: "100px",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                }}
                                data-bs-toggle="modal"
                                data-bs-target="#delete_patient"
                                onClick={() => {
                                  setDeleteId(getAdminUserData?.id);
                                }}
                              >
                                <i className="fa fa-trash-alt me-2" />
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {isLoading ? (
                      <div>
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={430} // Same height as your chart
                        />
                      </div>
                    ) : (
                      <div
                        style={{ marginLeft: "1rem", marginTop: "20px" }}
                        className="col-md-7"
                      >
                        <ul className="personal-info">
                          <li className="pb-1">
                            <span className="title">Id:</span>
                            <span className="text">{getAdminUserData?.id}</span>
                          </li>
                          <li className="pb-1">
                            <span className="title">Role:</span>
                            <span className="text">
                              {getAdminUserData?.role}
                            </span>
                          </li>
                          <li className="pb-1">
                            <span className="title">Email:</span>
                            <span className="text">
                              {getAdminUserData?.email}
                            </span>
                          </li>
                          <li className="pb-1">
                            <span className="title">Name:</span>
                            <span style={{textTransform:"capitalize"}} className="text">
                              {getAdminUserData?.name}
                            </span>
                          </li>
                          <li className="pb-1">
                            <span className="title">Current Sign In at:</span>
                            <span className="text">
                              {getAdminUserData?.current_sign_in_at || "NA"}
                            </span>
                          </li>
                          <li className="pb-1">
                            <span className="title">Sign In Count:</span>
                            <span className="text">
                              {getAdminUserData?.sign_in_count}
                            </span>
                          </li>
                          <li className="pb-1">
                            <span className="title">Created At:</span>
                            <span className="text">
                              {formatDate(getAdminUserData?.created_at)}
                            </span>
                          </li>
                          <li className="pb-1">
                            <span className="title">Updated At:</span>
                            <span className="text">
                              {formatDate(getAdminUserData?.updated_at)}
                            </span>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="delete_patient"
          className="modal fade delete-modal"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img src={imagesend} alt="#" width={50} height={46} />
                <h3>Are you sure want to delete this ?</h3>
                <div className="m-t-20">
                  {" "}
                  <Link
                    to="#"
                    className="btn btn-white me-2"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </Link>
                  <button
                    onClick={handleDeleteUserAdmin}
                    type="submit"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            id="delete_patient"
            className="modal fade delete-modal"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body text-center">
                  <img src={imagesend} alt="#" width={50} height={46} />
                  <h3>Are you sure want to delete this ?</h3>
                  <div className="m-t-20">
                    {" "}
                    <Link
                      to="#"
                      className="btn btn-white me-2"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </Link>
                    <button
                      data-bs-dismiss="modal"
                      type="submit"
                      className="btn btn-danger"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default AdminUserDetails;
